import getApi from '../api/getApi';
import postApi from '../api/postApi';
import axiosInstance from '../api/rootApi';

/** POST /booking — create a new booking */
export const createBooking = (data) => postApi('/booking', data);

/** GET /booking/:email — fetch bookings for a user by email */
export const fetchBookingsByEmail = (email) => getApi(`/booking/${email}`);

/** GET /allBookingProduct — fetch every booking (admin) */
export const fetchAllBookings = () => getApi('/allBookingProduct');

/** DELETE /booking/:id — delete a booking by ID */
export const deleteBooking = (id) =>
  axiosInstance.delete(`/booking/${id}`).then((r) => r.data);

/** PUT /booking/:id — mark a booking as Shipped */
export const updateBookingStatus = (id) =>
  axiosInstance.put(`/booking/${id}`).then((r) => r.data);
